import { render, staticRenderFns } from "./classification-results.vue?vue&type=template&id=37dfd3ba&"
import script from "./classification-results.vue?vue&type=script&lang=js&"
export * from "./classification-results.vue?vue&type=script&lang=js&"
import style0 from "./classification-results.vue?vue&type=style&index=0&id=37dfd3ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports